import Marquee from "react-fast-marquee";

const WORDS = [
  "Section 8",
  "Preservation",
  "PRAC",
  "Community",
  "LIHTC",
  "Stewardship",
  "North Carolina",
  "Longevity",
  "South Carolina",
];

export const EditorialMarquee = () => {
  return (
    <section
      data-testid="marquee-section"
      className="border-y border-[#1C2220]/10 bg-[#EEEAE0] py-8 md:py-10 overflow-hidden"
    >
      <Marquee speed={35} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="marquee-item px-8 md:px-14 text-3xl md:text-5xl text-[#1C2220] italic">
              {w}
            </span>
            <span className="h-2 w-2 rounded-full bg-[#C56A4E]" />
          </span>
        ))}
      </Marquee>
    </section>
  );
};

export default EditorialMarquee;
